import React, { useState } from 'react'
import { Modal, Button, Spin } from 'antd'
import { forceRetryBatch } from '../../../../../services/api/3dApi'
import Promise from "bluebird"

export const ActionForceRetry = ({ isOpen, closeModal, selectedItems, refreshBatches, toggleSelectAll, batches }) => {
    const [loading, setLoading] = useState(false)
    const [isChange, setIsChange] = useState(false)
    const [itemsSuccess, setItemsSuccess] = useState([])
    const [itemError, setItemError] = useState([])

    const listBatches = batches.filter(batch => selectedItems.includes(batch._id))

    const onChangeStatus = async () => {
        setLoading(true)
        setIsChange(true)

        await Promise.each(selectedItems, async item => {
            try {
                const { data: response } = await forceRetryBatch(item)
                const { success, error } = response

                if (!success) {
                    setLoading(false)
                    itemError.push({
                        _id: item,
                        message: error
                    })
                    setItemError([...itemError])
                } else {
                    itemsSuccess.push(item)
                    setItemsSuccess([...itemsSuccess])
                }

            } catch (e) {
                setLoading(false)
                throw Error(e.message)

            } finally {
                setLoading(false)
            }
        })
    }

    const _showMessage = (itemError, itemsSuccess, _id) => {
        if (itemError.find(itemErr => _id === itemErr._id) !== undefined) {
            if (itemError.find(itemErr => _id === itemErr._id).message) {
                return (
                    <span className="d-sm-block text-danger">
                        {itemError.find(itemErr => _id === itemErr._id).message}
                    </span>
                )
            } else {
                return (
                    <span className="d-sm-block">Loading...</span>
                )
            }
        } else if (itemsSuccess.includes(_id)) {
            return (
                <span className="d-sm-block text-success">Retry thành công!</span>
            )
        } else {
            return (
                <span className="d-sm-block">Waiting...</span>
            )
        }
    }

    const _hanldeClose = () => {
        closeModal()
        toggleSelectAll(false)
        refreshBatches()
    }

    return (
        <Modal
            title="Force retry"
            visible={isOpen}
            onOk={onChangeStatus}
            onCancel={closeModal}
            footer={[
                <Button key="back" onClick={closeModal} className={!isChange ? "" : "d-none"}>
                    Hủy
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={onChangeStatus}
                    className={!isChange ? "" : "d-none"}
                >
                    Force retry
                </Button>,
                <Button onClick={_hanldeClose} className={`bg-grey ml-2 ${isChange ? "" : "d-none"}`}>
                    Close
                </Button>
            ]}
        >
            {!isChange ?
                <div className='status-force'>
                    <h6>Xác nhận download / gộp file in của {selectedItems.length} lô.</h6>
                </div>
                : (
                    <div className="ListChangeStatusBatch">
                        {listBatches.length > 0 && (
                            listBatches.map(item => {
                                return (
                                    <div key={item._id} className="ItemGenLabel d-sm-flex mb-2 pb-2">
                                        <div className="IconStatus mr-2 d-flex align-items-end">
                                            {itemsSuccess.includes(item._id) && (
                                                <Button icon="check" className='icon-check text-success'></Button>
                                            )}
                                            {
                                                (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemError.find(itemErr => item._id === itemErr._id).message) && (
                                                    <Button icon="cross" className='icon-cross text-danger'></Button>
                                                )
                                            }
                                        </div>
                                        <div className="ContentGenLabel">
                                            <strong className='mr-2'>{item.name}</strong>
                                            {loading && <Spin />}
                                            {_showMessage(itemError, itemsSuccess, item._id)}
                                        </div>
                                    </div>
                                )
                            })
                        )}
                    </div>
                )
            }
        </Modal>
    )
}
